import { connect } from 'react-redux'
import MyList from '../components/MyList'

const renderMailTo = (items) => {
  const mailAddress = 'support@selects.jp'
  const mailSubject = 'selects商品希望リスト'
  const mailBody = encodeURIComponent(mailSubject+'\n\n'+'・TZ-12345 : 鉄木柄フライパン16cm - 2,000円\n')
  // const content = items.map(item =>
  //   '・'+item.品番+' : '+item.商品名+' - '+toLocaleString(item.価格)+'円\n'
  // )
  return 'mailto:'+mailAddress+'?subject='+mailSubject+'&body='+mailBody
}

const mapStateToProps = (state, props) => {
  const { items, images } = state
  const mailto = renderMailTo()
  const myListNum = items.length
  return { mailto, items, images, myListNum }
}

const container = connect(
  mapStateToProps,
  {}
)(MyList)

export default container



// WEBPACK FOOTER //
// ./src/containers/MyList.js